import React from 'react';
import 'reactjs-popup/dist/index.css';
import '../../App.css';
import '../../bootstrap.css';
import FoodLoggingForm2 from './FoodLoggingForm2';
import * as Database from '../../helpers/Database';
import * as Analytics from '../../helpers/Analytics';
import RecipeBuilder from './RecipeBuilder';
import {
  mapFoodFormEntryToPartialDataEntry, dataEntryContentAreEqual
} from '../../helpers/Util';
let _ = require('lodash');

export default class DataEntryTodoForm extends React.Component {
  constructor(props) {
    super(props);
    this._needsHelpMessage = '';
    this._lastNeededHelp = this.props.dataEntryContent ? this.props.dataEntryContent.lastNeededHelp : null;

    this.state = {
      showFoodLoggingForm: false,
      showRecipeBuilder: false,
      promptDeletion: false,
      promptNeedsHelp: false,
      needsHelp: this.props.dataEntryContent ? !!this.props.dataEntryContent.needsHelp : false,
      recipeName: null, // We'll default to using this.props.dataEntryContent.name until this is explicitly set in _updateRecipe.
      totalServings: this.props.dataEntryContent ? this.props.dataEntryContent.totalServings : null,
      disableUpdateRecipeBtn: false,
      dataEntryContentToAutopopForm: this._getDataEntryObj(this.props.dataEntryContent),
      needHelpErrorMessage: '',
    };
  }

  _getDataEntryObj(dataEntryContent) {
    return dataEntryContent.category === 'food' ? dataEntryContent : null;
  }

  componentWillReceiveProps(nextProps) {
    if (!dataEntryContentAreEqual(nextProps.dataEntryContent, this.props.dataEntryContent)) {
      this.setState({
        dataEntryContentToAutopopForm: this._getDataEntryObj(nextProps.dataEntryContent)
      });
    }
  }

  toggleShowFoodForm = () => {
    this.setState({
      showFoodLoggingForm: !this.state.showFoodLoggingForm
    });
  }

  toggleShowRecipeBuilder = () => {
    this.setState({
      showRecipeBuilder: !this.state.showRecipeBuilder
    });
  }

  _updateRecipe = async (name, ingredients, totalServings) => {
    this.setState({
      disableUpdateRecipeBtn: true,
    });

    await Database.rebuildRecipeCart(this.props.userId, this.props.todoId, ingredients, totalServings);
    this.setState({
      recipeName: name,
      showRecipeBuilder: true,
      showFoodLoggingForm: false,
      totalServings: totalServings,
      disableUpdateRecipeBtn: false,
    });
  }

  onDataEntrySubmit = async (foodFormEntry) => {
    const newDataEntryContent = mapFoodFormEntryToPartialDataEntry(foodFormEntry);
    // updateDataEntryTodoAsync will do a merge, not overwrite.
    const successfulUpdate = await Database.updateDataEntryTodoAsync(this.props.userId, this.props.todoId, newDataEntryContent, this.props.userStatus.name);
    if (!successfulUpdate) {
      this.setState({
        needsHelp: true,
        needHelpErrorMessage: '',
      });
    }
    this.props.onItemConfirmedOrStatusChange();
    this.toggleShowFoodForm();
  }

  _deleteTodoAsync = async () => {
    await Database.deleteUserFoodTodo(this.props.userId, this.props.todoId);
    this.props.onItemConfirmedOrStatusChange();
  }

  _togglePromptDeletion = () => {
    this.setState({
      promptDeletion: !this.state.promptDeletion
    });
  }

  _buildPromptDeletionPopup = () => {
    return (
      <span style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
        <div style={{
          width: '400px',
          height: '300px',
          borderWidth: '2px',
          borderColor: 'black',
          border: 'solid',
          position: 'absolute',
          backgroundColor: 'white',
          right: '50%',
          bottom: '50%',
          zIndex: '100',
          padding: '10px'
        }}
        >
          <div>ARE YOU SURE? Once you delete this todo, you can NOT recover it. You should only do so if this food is duplicate or a mistake.</div>
          <button style={{ margin: '10px' }} onClick={this._deleteTodoAsync}>
            Yes, Delete
          </button>
          <button style={{ margin: '10px' }} onClick={this._togglePromptDeletion}>
            No, Cancel
          </button>
        </div>
      </span>
    );
  }

  _checkedNeedsHelpBox = (event) => {
    if (event.target.checked) {
      this._togglePromptNeedsHelp(true);
    } else {
      this._disableNeedsHelp();
    }
  }

  _disableNeedsHelp = async () => {
    // This must finish before we call this.props.onItemConfirmedOrStatusChange();
    await Database.updateDataEntryTodoAsync(this.props.userId, this.props.todoId, {
      'needsHelp': false, // Don't also remove lastNeededHelp field because we use it during submit and also for analytics.
    }, this.props.userStatus.name);
    this.setState({
      needsHelp: false
    });

    this._togglePromptNeedsHelp(false);

    const coachTurnaroundTime = Date.now() - this._lastNeededHelp;
    if (coachTurnaroundTime) { // Could be NaN if DEP checked a box and then decided not to send message (which internally "unchecks" the box again). In that case, don't count this in Analytics.
      Analytics.logDEPNeedsHelp(this.props.userId, this.props.adminId, 'Resolved', coachTurnaroundTime / 1000);
    }

    this.props.onItemConfirmedOrStatusChange();
  }

  _togglePromptNeedsHelp = (show) => {
    this.setState({
      promptNeedsHelp: show
    });
  }

  _enableNeedsHelp = async () => {
    if (_.isEmpty(this._needsHelpMessage)) {
      this.setState({
        needHelpErrorMessage: 'A message is required',
      });
      return;
    }

    let revisionHistory = '\n';
    if (this._hasRevisionHistory()) {
      for (let revisionLine of this.props.dataEntryContent.revisionHistory) {
        revisionHistory += this._escapeCharsForSlack(revisionLine) + '\n';
      }
    }

    let imageUrl = this._hasImages() ? this.props.dataEntryContent.images[0] : '';

    const message = `Need help for ${this.props.userStatus.name} ` + this._escapeCharsForSlack(this._needsHelpMessage) + revisionHistory + imageUrl;

    fetch(process.env.REACT_APP_API_URL + '/pingSlackChannel', {
      method: 'POST',
      body: JSON.stringify({
        channelName: 'manualDataEntry',
        message: message
      }),
      headers: { "Content-Type": "application/json" }
    });

    this._lastNeededHelp = Date.now();
    // This must finish before we call this.props.onItemConfirmedOrStatusChange();
    await Database.updateDataEntryTodoAsync(this.props.userId, this.props.todoId, {
      'needsHelp': true,
      'lastNeededHelp': this._lastNeededHelp
    }, this.props.userStatus.name);
    this.setState({
      needsHelp: true,
      needHelpErrorMessage: '',
    });
    this._togglePromptNeedsHelp(false);

    this.props.onItemConfirmedOrStatusChange();
    Analytics.logDEPNeedsHelp(this.props.userId, this.props.adminId, 'Open', 0);
  }

  _buildPromptNeedsHelpPopup = () => {
    return (
      <span style={{ position: 'absolute', top: '300px', right: '10px' }}>
        <div style={{
          width: '400px',
          height: '300px',
          borderWidth: '2px',
          borderColor: 'black',
          border: 'solid',
          position: 'absolute',
          backgroundColor: 'white',
          right: '50%',
          bottom: '50%',
          zIndex: '100',
          padding: '10px'
        }}
        >
          <div >
            <textarea style={{ width: "-webkit-fill-available" }}
              rows='6'
              placeholder="(Required) Type your question here."
              onChange={this._needsHelpMessageChange}
            ></textarea>
          </div>
          <div style={{ color: 'red' }}>{this.state.needHelpErrorMessage}</div>
          <button style={{ margin: '10px' }} onClick={this._enableNeedsHelp}>
            Send
          </button>
          <button style={{ margin: '10px' }} onClick={this._disableNeedsHelp}>
            Cancel
          </button>
        </div>
      </span>
    );
  }

  _needsHelpMessageChange = (e) => {
    this._needsHelpMessage = e.target.value;
  }

  _escapeCharsForSlack = (text) => {
    // Some characters are not accepted by Slack API and needs escaping.
    // I couldn't figur out how to do that in a timely manner, so I'm just going to
    // replace these with &text description&.
    let formattedText = text.replaceAll('"', '&quote&');
    formattedText = formattedText.replaceAll("'", "&quote&");
    formattedText = formattedText.replaceAll("\\", "&backslash&");
    formattedText = formattedText.replaceAll("<", "&open-caret&");
    formattedText = formattedText.replaceAll(">", "&close-caret&");
    return formattedText;
  }

  _hasRevisionHistory = () => {
    return !(_.isEmpty(this.props.dataEntryContent.revisionHistory) || this.props.dataEntryContent.revisionHistory.length < 1);
  }

  _hasImages = () => {
    return this.props.dataEntryContent.images && this.props.dataEntryContent.images[0];
  }

  render() {
    let manuallyCheckedAlready = this.props.dataEntryContent.manualPick;
    let hasRevisionHistory = this._hasRevisionHistory();
    let latestRevisionText = hasRevisionHistory
      ? this.props.dataEntryContent.revisionHistory[this.props.dataEntryContent.revisionHistory.length - 1]
      : this.props.dataEntryContent.originalText;

    let mainBgColor = this.state.promptDeletion ? 'red' : 'white';
    let foodLoggingForm = <FoodLoggingForm2
      userId={this.props.userId}
      userStatus={this.props.userStatus}
      adminId={this.props.adminId}
      todoId={this.props.todoId}
      dataEntryObj={this.state.dataEntryContentToAutopopForm}
      targetDate={this.props.dataEntryContent.targetDate}
      onSubmit={this.onDataEntrySubmit}
      onClose={this.toggleShowFoodForm}
      hasImages={this.props.dataEntryContent.images && this.props.dataEntryContent.images[0]}
      togglePromptHeedsHelp={this._togglePromptNeedsHelp}
      updateRecipe={this.state.disableUpdateRecipeBtn ? null : this._updateRecipe}
      foodTagRequired={true}
    />;

    let recipeBuilder = <RecipeBuilder
      recipeName={this.state.recipeName ? this.state.recipeName : this.props.dataEntryContent.name}
      userId={this.props.userId}
      targetDate={this.props.dataEntryContent.targetDate}
      userStatus={this.props.userStatus}
      adminId={this.props.adminId}
      onClose={this.toggleShowRecipeBuilder}
      emptyCartAfterSubmit={false}
      onSubmitEverything={() => {
        this.toggleShowRecipeBuilder();
        //this.toggleShowFoodForm(); Dont toggle show food form because it'll still pre-populate with outdated values before the setState below finishes completing
        this.setState({
          // Clear this so it doesn't populate with old values.
          dataEntryContentToAutopopForm: null
        });
      }}
      logId={this.props.todoId}
      totalServings={this.state.totalServings}
    />;
    let showFoodLogginFormButton = <div>
      <input
        type='submit'
        value='Lookup Food'
        onClick={this.toggleShowFoodForm}
      >
      </input>
    </div>;
    let makeRecipeButton = <div>
      <input
        type='submit'
        value='Make/Edit Recipe'
        onClick={this.toggleShowRecipeBuilder}
      >
      </input>
    </div>;
    let deleteButton = <div>
      {this.state.promptDeletion ? this._buildPromptDeletionPopup() : <span />}
      <div style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
        <input type="submit" onClick={this._togglePromptDeletion} value="Delete" style={{ marginRight: '10px' }} />
      </div>
    </div>;

    return (
      <div className='row' value={this.props.todoId} style={{
        margin: '10px',
        padding: '10 px',
        backgroundColor: this.state.needsHelp ? 'silver' : (manuallyCheckedAlready ? 'palegreen' : 'pink')
      }}>
        <div className='col-3' style={{ margin: '10px', padding: '10px', backgroundColor: mainBgColor }}>
          {
            this._hasImages() ?
              <img alt="(picture)" style={{ maxWidth: "100%" }} src={this.props.dataEntryContent.images[0]}></img> :
              <span />
          }

          {
            hasRevisionHistory ?
              <div>
                <b>Log History:</b>
                <ol reversed>
                  {
                    this.props.dataEntryContent.revisionHistory.toReversed().map(revisionText => {
                      var revisionTextLines = revisionText.split('\n');
                      return <li
                        key={revisionText}
                        style={{
                          wordWrap: 'break-word',
                          backgroundColor: (latestRevisionText === revisionText) ? 'yellow' : 'white',
                          color: (latestRevisionText === revisionText) ? 'black' : 'gray'
                        }}
                      >
                        {
                          revisionTextLines.map(revisionLine => {
                            return <div key={revisionLine} dangerouslySetInnerHTML={{ __html: revisionLine }} />;
                          })
                        }
                      </li>
                    })
                  }
                </ol>
              </div>
              : <span />
          }
          {hasRevisionHistory ? <span /> : <div style={{ backgroundColor: 'yellow' }}>Original text: "{this.props.dataEntryContent.originalText}"</div>}
          <hr />
          <div>Target Date: {this.props.dataEntryContent.targetDate}</div>
        </div>
        {
          this.state.showRecipeBuilder ? <span /> :
            <div className='col-2' style={{ margin: '10px', padding: '10px', backgroundColor: mainBgColor }}>
              {
                manuallyCheckedAlready ?
                  <div>✅ You confirmed: <hr />
                    {
                      this.props.dataEntryContent.topHitName ?
                        <div>
                          <div>
                            You picked:&nbsp;
                            <b>{this.props.dataEntryContent.consolidatedServingName} {this.props.dataEntryContent.topHitName}</b>
                          </div>
                          <ul>
                            <li>{this.props.dataEntryContent.calories} calories</li>
                            <li>{this.props.dataEntryContent.fat} fat</li>
                            <li>{this.props.dataEntryContent.carbs} carbs</li>
                            <li>{this.props.dataEntryContent.protein} protein</li>
                          </ul>
                        </div> :
                        <div>Couldn't find a match.</div>
                    }
                  </div>
                  :
                  <div style={{ color: "red" }}>⚠️ Please confirm ➡️<hr /></div>
              }
            </div>
        }
        <div className='col' style={{ margin: '10px', padding: '10px', backgroundColor: mainBgColor }}>
          <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
            <span>Need help</span>&nbsp;<input type="checkbox" checked={this.state.needsHelp} onChange={this._checkedNeedsHelpBox} />
          </div>
          <div style={{ marginTop: '10px' }}>
            <p>If user logged multiple foods, click "Make/Edit Recipe"</p>
          </div>
          {this.state.promptNeedsHelp ? this._buildPromptNeedsHelpPopup() : <span />}
          {
            this.state.showFoodLoggingForm ?
              foodLoggingForm :
              (!this.state.showRecipeBuilder ? showFoodLogginFormButton : <span />)
          }
          <div style={{ paddingTop: '10px' }} />
          {
            this.state.showRecipeBuilder ?
              recipeBuilder :
              (!this.state.showFoodLoggingForm ? makeRecipeButton : <span />)
          }
          {
            !this.state.showFoodLoggingForm && !this.state.showRecipeBuilder ? deleteButton : <span />
          }
        </div>
      </div >
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/foodLogging/DataEntryTodoForm.js